import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    FormControlLabel,
    Checkbox
} from '@mui/material'
import { useEffect, useState } from 'react'
import axios from 'axios'
import apiUrl from '../../configs/constant'
import { useToast } from '../../components/ToastProvider'

/* =========================
   TYPES
   ========================= */

type Tag = {
    id: number
    kode: string
    name: string
    hex_color: string
    icon: string
}

type Props = {
    open: boolean
    contact?: {
        id: number
        sdcust_id: any
        tags?: Tag[]
    }
    onClose: () => void
    onReload: () => void
}

export default function DialogTag({
    open,
    contact,
    onClose,
    onReload
}: Props) {
    const { showToast } = useToast()

    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    const [listTags, setListTags] = useState<Tag[]>([])
    const [selectedTags, setSelectedTags] = useState<Tag[]>([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getTags()
    }, [])

    useEffect(() => {
        if (open && contact?.tags) {
            setSelectedTags(contact.tags)
        }
    }, [open, contact])

    const getTags = async () => {
        try {
            const res = await axios.get(
                apiUrl.apiUrl + '/omni/chat/get-tags',
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )

            if (res.data.success) {
                setListTags(res.data.data)
            } else {
                showToast(res.data.message, 'error')
            }
        } catch {
            showToast('Gagal mengambil tag', 'error')
        }
    }

    const toggleTag = (tag: Tag) => {
        setSelectedTags(prev =>
            prev.some(t => t.id === tag.id)
                ? prev.filter(t => t.id !== tag.id)
                : [...prev, tag]
        )
    }

    const saveTags = async () => {
        if (!contact) return

        setLoading(true)

        try {
            const payload = {
                sdcust_id: contact?.sdcust_id,
                tag_ids: selectedTags.map(t => t.id)
            }

            const res = await axios.post(
                apiUrl.apiUrl + '/omni/chat/save-tags',
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            )

            if (res.data.success) {
                showToast('Tag berhasil disimpan', 'success')
                onClose()
                onReload()
            } else {
                showToast(res.data.message, 'error')
            }
        } catch {
            showToast('Gagal menyimpan tag', 'error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Tags</DialogTitle>

            <DialogContent dividers>
                {!contact ? (
                    <div>Pilih contact terlebih dahulu</div>
                ) : (
                    <Stack spacing={1}>
                        {listTags.map(tag => (
                            <FormControlLabel
                                key={tag.id}
                                control={
                                    <Checkbox
                                        checked={selectedTags.some(t => t.id === tag.id)}
                                        onChange={() => toggleTag(tag)}
                                        disabled={loading}
                                    />
                                }
                                label={
                                    <span style={{ color: tag.hex_color }}>
                                        {tag.name}
                                    </span>
                                }
                            />
                        ))}
                    </Stack>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Tutup
                </Button>
                <Button
                    variant="contained"
                    onClick={saveTags}
                    disabled={!contact || loading}
                >
                    Simpan
                </Button>
            </DialogActions>
        </Dialog>
    )
}
